import { Routes } from '@angular/router';
import { OpenSquashComponent } from './opensquash/open-squash-component/open-squash-component';
import { InfoComponent } from './opensquash/info-component/info-component';
import { CategoryComponent } from './opensquash/category-component/category-component';
import { Info7moopenComponent } from './opensquash/info7moopen-component/info7moopen-component';
import { Open7Component } from './opensquash/open7-component/open7-component';
import { InfoConcJuvenil2024 } from './opensquash/info-conc-juvenil-2024/info-conc-juvenil-2024';
import { ConcJuvenil2024 } from './opensquash/conc-juvenil-2024/conc-juvenil-2024';
import { VValidaDepartamentalComponent } from './opensquash/v-valida-departamental-component/v-valida-departamental-component';
import { InfoVValidaDepartamental } from './opensquash/info-v-valida-departamental/info-v-valida-departamental';
import { Open8Component } from './opensquash/open8-component/open8-component';
import { Open8InfoComponent } from './opensquash/open8-info-component/open8-info-component';
import { Open9Component } from './opensquash/open9-component/open9-component';
import { Open9InfoComponent } from './opensquash/open9-info-component/open9-info-component';
import { Open10Component } from './opensquash/open10-component/open10-component';
import { Open10InfoComponent } from './opensquash/open10-info-component/open10-info-component';
import { Open11Component } from './opensquash/open11-component/open11-component';
import { Open11InfoComponent } from './opensquash/open11-info-component/open11-info-component';
import { Open12Component } from './opensquash/open12-component/open12-component';
import { Open12InfoComponent } from './opensquash/open12-info-component/open12-info-component';
import { Open13Component } from './opensquash/open13-component/open13-component';
import { Open13InfoComponent } from './opensquash/open13-info-component/open13-info-component';
import { OpenFemenino1Component } from './opensquash/open-femenino1-component/open-femenino1-component';
import { OpenFemenino1InfoComponent } from './opensquash/open-femenino1-info-component/open-femenino1-info-component';
import { IValidaAnt2026Component } from './opensquash/i-valida-ant-2026-component/i-valida-ant-2026-component';
import { IValidaAnt2026InfoComponent } from './opensquash/i-valida-ant-2026-info-component/i-valida-ant-2026-info-component';
import { MatchRefereeComponent } from './opensquash/match-referee/match-referee.component';
import { TournamentControlComponent } from './opensquash/tournament-control-component/tournament-control-component';
import { TournamentDisplayBoardComponent } from './opensquash/tournament-display-board/tournament-display-board';

// Rutas standalone para espectadores (cancha en vivo) y QRs imprimibles.
// Se declaran ANTES de los shells de torneo para que matcheen primero y la
// vista se cargue fullscreen sin el header/tabs del torneo (mismo patrón que el referee).
// Cada par cancha/qr-canchas usa `data.tournamentId` (Firestore) y `data.slug` (URL).
const standaloneTournamentViews: Routes = [
    { tournamentId: '9open',             slug: 'open9' },
    { tournamentId: '10open',            slug: 'open10' },
    { tournamentId: '11open',            slug: 'open11' },
    { tournamentId: '12open',            slug: 'open12' },
    { tournamentId: '13open',            slug: 'open13' },
    { tournamentId: '1open-femenino',    slug: 'open-femenino1' },
    { tournamentId: 'i-valida-ant-2026', slug: 'i-valida-ant-2026' },
].flatMap(({ tournamentId, slug }) => [
    {
        path: `${slug}/cancha/:courtNumber`,
        loadComponent: () => import('./opensquash/match-live-spectator/match-live-spectator.component')
            .then(m => m.MatchLiveSpectatorComponent),
        data: { tournamentId, slug },
    },
    {
        path: `${slug}/qr-canchas`,
        loadComponent: () => import('./opensquash/courts-qr-printable/courts-qr-printable.component')
            .then(m => m.CourtsQrPrintableComponent),
        data: { tournamentId, slug },
    },
]);

export const routes: Routes = [
    {
        path: 'referee/:matchCode',
        component: MatchRefereeComponent,
    },
    ...standaloneTournamentViews,
    {
        // Micrositio III Concentración Juvenil de Squash 2026 (Ríos Squash · EN-FOCUS · Bolar)
        path: 'concentracion-juvenil-3',
        loadChildren: () => import('./conc-juvenil-3/conc-juvenil-3.routes'),
    },
    {
        path: '7mo-open',
        component: Open7Component,
        children: [
            {
                path: 'category/:categoryType',
                component: CategoryComponent,
            },
            {
                path: 'info',
                component: Info7moopenComponent,
            },
            {
                path: '',
                redirectTo: 'info',
                pathMatch: 'full',
            },
        ],
    },
    {
        path: 'open8',
        component: Open8Component,
        children: [
            {
                path: 'category/:categoryType',
                component: CategoryComponent,
            },
            {
                path: 'info',
                component: Open8InfoComponent
            },
            {
                path: '',
                redirectTo: 'info',
                pathMatch: 'full',
            },
        ],
    },
    {
        path: 'iv-valida-departamental',
        component: OpenSquashComponent,
        children: [
            {
                path: 'category/:categoryType',
                component: CategoryComponent,
            },
            {
                path: 'info',
                component: InfoComponent,
            },
            {
                path: '',
                redirectTo: 'info',
                pathMatch: 'full',
            },
        ],
    },
    {
        path: 'concentracion-juvenil-2025',
        component: ConcJuvenil2024,
        children: [
            {
                path: 'category/:categoryType',
                component: CategoryComponent,
            },
            {
                path: 'info',
                component: InfoConcJuvenil2024,
            },
            {
                path: '',
                redirectTo: 'info',
                pathMatch: 'full',
            },
        ],
    },
    {
        path: 'v-valida-departamental',
        component: VValidaDepartamentalComponent,
        children: [
            {
                path: 'category/:categoryType',
                component: CategoryComponent,
            },
            {
                path: 'info',
                component: InfoVValidaDepartamental,
            },
            {
                path: '',
                redirectTo: 'info',
                pathMatch: 'full',
            },
        ],
    },
    {
        path: 'open9',
        component: Open9Component,
        children: [
            {
                path: 'category/:categoryType',
                component: CategoryComponent,
            },
            {
                path: 'info',
                component: Open9InfoComponent
            },
            {
                path: 'control',
                component: TournamentControlComponent,
            },
            {
                path: '',
                redirectTo: 'info',
                pathMatch: 'full',
            },
        ],
    },
    {
        path: 'open10',
        component: Open10Component,
        children: [
            {
                path: 'category/:categoryType',
                component: CategoryComponent,
            },
            {
                path: 'info',
                component: Open10InfoComponent
            },
            {
                path: 'control',
                component: TournamentControlComponent,
            },
            {
                path: '',
                redirectTo: 'info',
                pathMatch: 'full',
            },
        ],
    },
    {
        path: 'open11',
        component: Open11Component,
        children: [
            {
                path: 'category/:categoryType',
                component: CategoryComponent,
            },
            {
                path: 'info',
                component: Open11InfoComponent
            },
            {
                path: 'control',
                component: TournamentControlComponent,
            },{
                path: 'tablero',
                component: TournamentDisplayBoardComponent,
            },
            {
                path: '',
                redirectTo: 'info',
                pathMatch: 'full',
            },
        ],
    },
    {
        path: 'open12',
        component: Open12Component,
        children: [
            {
                path: 'category/:categoryType',
                component: CategoryComponent,
            },
            {
                path: 'info',
                component: Open12InfoComponent
            },
            {
                path: 'control',
                component: TournamentControlComponent,
            },
            {
                path: 'tablero',
                component: TournamentDisplayBoardComponent,
            },
            {
                path: '',
                redirectTo: 'info',
                pathMatch: 'full',
            },
        ],
    },
    {
        path: 'open13',
        component: Open13Component,
        children: [
            {
                path: 'category/:categoryType',
                component: CategoryComponent,
            },
            {
                path: 'info',
                component: Open13InfoComponent
            },
            {
                path: 'control',
                component: TournamentControlComponent,
            },
            {
                path: 'tablero',
                component: TournamentDisplayBoardComponent,
            },
            {
                path: '',
                redirectTo: 'info',
                pathMatch: 'full',
            },
        ],
    },
    {
        path: 'open-femenino1',
        component: OpenFemenino1Component,
        children: [
            {
                path: 'category/:categoryType',
                component: CategoryComponent,
            },
            {
                path: 'info',
                component: OpenFemenino1InfoComponent
            },
            {
                path: 'control',
                component: TournamentControlComponent,
            },
            {
                path: 'tablero',
                component: TournamentDisplayBoardComponent,
            },
            {
                path: '',
                redirectTo: 'info',
                pathMatch: 'full',
            },
        ],
    },
    {
        path: 'i-valida-ant-2026',
        component: IValidaAnt2026Component,
        children: [
            {
                path: 'category/:categoryType',
                component: CategoryComponent,
            },
            {
                path: 'info',
                component: IValidaAnt2026InfoComponent
            },
            {
                path: 'control',
                component: TournamentControlComponent,
            },
            {
                path: 'tablero',
                component: TournamentDisplayBoardComponent,
            },
            {
                path: '',
                redirectTo: 'info',
                pathMatch: 'full',
            },
        ],
    },
    {
        path: '',
        redirectTo: 'open-femenino1',
        pathMatch: 'full',
    },
];
